/* eslint-disable */
import debounce from 'lodash/debounce';

window.API = {};
window.API_1484_11 = {};
window.data = {};
const flag = {};
flag.flagFinished = false;
flag.flagInitialized = false;
SCORM.errorCode = '0';

export function getFlagValue(flagName) {
  return flag[flagName];
}

export function setFlagValue(flagName, value) {
  flag[flagName] = value;
}

API.LMSGetValue_F = function(key) {
  return data[key];
};

API.LMSGetValue = function(key) {
  console.log('LMS 1.2 GetValue::', key, data[key]);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    SCORM.errorCode = '301';
    return '';
  }

  if (!SCORM.isSupported(key)) {
    SCORM.errorCode = '401';
    return '';
  }

  if (!SCORM.dataElementRead) {
    SCORM.errorCode = '404';
    return '';
  }

  SCORM.errorCode = '0';
  if (key === 'cmi.interactions._count') {
    return data['cmi.interactions'].length;
  }
  return data[key] || '';
};

API_1484_11.GetValue = function(key) {
  console.log('LMS 2004 GetValue::', key);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    SCORM.errorCode = '301';
    return '';
  }

  if (!SCORM.isSupported(key)) {
    SCORM.errorCode = '401';
    return '';
  }

  if (!SCORM.dataElementRead) {
    SCORM.errorCode = '404';
    return '';
  }
  SCORM.errorCode = '0';
  return data[key];
};

API.LMSSetValue_F = function(key, val) {
  data[key] = val;
};

// const interactionsArr = [];
function generateInteractionsArray(key, val) {
  // console.log('Before Generating Array::', key.split(/.[\d]./g));
  // setValue('cmi.interation.2.id')
  const levelRegEx = /[\.](\d+)[\.]/g;
  let tempArr;
  const numArr = [];
  while ((tempArr = levelRegEx.exec(key)) !== null) {
    numArr.push(parseInt(tempArr[1], 10));
  }

  const interactionsArr = data['cmi.interactions'];

  if (numArr.length >= 1) {
    // const tempObj = {};
    const firstVar = key.split(/\.[\d]+\./g)[1];
    if (firstVar.indexOf('objectives') === -1 && firstVar.indexOf('correct_responses') < 0) {
      if (interactionsArr[numArr[0]] && interactionsArr.length >= numArr[0]) {
        interactionsArr[numArr[0]][firstVar] = val;
      } else if (interactionsArr.length >= numArr[0]) {
        interactionsArr[numArr[0]] = {};
        interactionsArr[numArr[0]][firstVar] = val;
      }
    } else if (interactionsArr.length >= numArr[0] && interactionsArr[numArr[0]] === undefined) {
      interactionsArr[numArr[0]] = {};
    }
  }
  if (numArr.length === 2) {
    const secondVar = key.split(/\.[\d]+\./g)[2];
    // const secondLevel = key.split(/.[\d]./g)[2];
    const SECOND_ARRAY_KEY = key.split(/\.[\d]+\./g)[1] || '';

    if (key.indexOf(SECOND_ARRAY_KEY) > 15) {
      interactionsArr[numArr[0]][SECOND_ARRAY_KEY] = !interactionsArr[numArr[0]][SECOND_ARRAY_KEY]
        ? []
        : interactionsArr[numArr[0]][SECOND_ARRAY_KEY];
      if (
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY][numArr[1]] &&
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY].length >= numArr[1]
      ) {
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY][numArr[1]][secondVar] = val;
      } else if (
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY][numArr[1]] === undefined &&
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY].length >= numArr[1]
      ) {
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY][numArr[1]] = {};
        interactionsArr[numArr[0]][SECOND_ARRAY_KEY][numArr[1]][secondVar] = val;
      }
    }
  }

  return interactionsArr;
}

API.LMSCommit = function(commitInput, callFromFinish) {
  console.log('LMS 1.2 Commit::', commitInput);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    return false;
  }
  if (callFromFinish) {
    scormObj.submitSCORMData(data, callFromFinish);
  } else {
    scormObj.submitSCORMData(data);
  }
  return true;
};

API.LMSSetValue = function(key, val) {
  console.log('LMS 1.2 SetValue::' + key + '=' + val);

  /* BIG HACK TO MANUALLY COMPLETE LESSON FOR SPRINKLR */
  if (
    key === 'cmi.core.lesson_status' &&
    val === 'passed' &&
    API.LMSGetValue('cmi.core.lesson_status') !== 'passed'
  ) {
    data[key] = val;
    SCORM.errorCode = '0';
    API.LMSFinish('');
  }

  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    SCORM.errorCode = '301';
    return '';
  }

  if (!SCORM.isSupported(key)) {
    SCORM.errorCode = '401';
    return false;
  }

  if (!SCORM.dataElementWrite) {
    SCORM.errorCode = '403';
    return false;
  }

  if (key.indexOf('cmi.interactions') > -1) {
    data['cmi.interactions'] = generateInteractionsArray(key, val);
    SCORM.errorCode = '0';
    return true;
  }

  data[key] = val;
  SCORM.errorCode = '0';

  /** IMP:: saving data to remote after LMS set value */
  // API.Commit('');
  debounce(() => API.LMSCommit(''), 1000);

  return true;
};

API_1484_11.Commit = function(commitInput) {
  console.log('LMS 2004 Commit::', commitInput);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    return false;
  }
  scormObj.submitSCORMData(data);
  return true;
};

API_1484_11.SetValue = function(key, val) {
  console.log('LMS 2004 SetValue::' + key + '=' + val);
  if (!getFlagValue('flagInitialized') || getFlagValue('flagFinished')) {
    SCORM.errorCode = '301';
    return '';
  }

  if (!SCORM.isSupported(key)) {
    SCORM.errorCode = '401';
    return false;
  }

  if (!SCORM.dataElementWrite) {
    SCORM.errorCode = '403';
    return false;
  }
  // if ( key === 'cmi.session_time') {
  //   console.log('Session time value', data, data['cmi.session_time']);
  // }
  data[key] = val;
  SCORM.errorCode = '0';

  /** IMP:: saving data to remote after LMS set value */
  debounce(() => API_1484_11.Commit(''), 1000);

  return true;
};

API.LMSGetLastError = function() {
  console.log('LMS 1.2 GetLastError::', SCORM.errorCode);
  return SCORM.errorCode;
};

API_1484_11.GetLastError = function() {
  console.log('LMS 2004 GetLastError::', SCORM.errorCode);
  return SCORM.errorCode;
};

API.LMSGetErrorString = function(errorCode) {
  console.log('LMS 1.2 GetLastErrorString::', SCORM.errorCode);
  return SCORM.errorMessages[errorCode];
};

API_1484_11.GetErrorString = function(errorCode) {
  console.log('LMS 2004 GetLastErrorString::', SCORM.errorCode);
  return SCORM.errorMessages[errorCode];
};

API.LMSGetDiagnostic = function(errorCode) {
  console.log('LMS 1.2 GetDiagnostic::', errorCode);
  return SCORM.errorMessages[errorCode];
};

API_1484_11.GetDiagnostic = function(errorCode) {
  console.log('LMS 2004 GetDiagnostics::', errorCode);
  return SCORM.errorMessages[errorCode];
};
